import { apiRequest } from "@/lib/api";

export interface AdminWarehouse {
  id: string;
  code: string;
  name: string;
  address: string | null;
  isDefault: boolean;
  isActive: boolean;
  createdAt: string;
}

export interface AdminInventoryBalance {
  productId: string;
  productName: string;
  productSku: string | null;
  warehouseId: string;
  warehouseCode: string;
  warehouseName: string;
  qty: number;
  avgUnitCost: number;
  totalValue: number;
  lastMovementAt: string | null;
}

export interface AdminInventoryMovement {
  id: string;
  createdAt: string;
  kind: string;
  direction: "in" | "out";
  qty: number;
  unitCost: number;
  totalCost: number;
  qtyAfter: number;
  avgCostAfter: number;
  productName: string | null;
  productSku: string | null;
  warehouseCode: string | null;
  warehouseName: string | null;
  sourceKind: string;
  sourceDocumentId: string | null;
}

export function listAdminInventoryWarehouses(
  companyId: string,
): Promise<{ warehouses: AdminWarehouse[] }> {
  return apiRequest(
    `/api/admin/companies/${encodeURIComponent(companyId)}/inventory/warehouses`,
  );
}

export function listAdminInventoryBalances(
  companyId: string,
  params: { warehouseId?: string },
): Promise<{
  balances: AdminInventoryBalance[];
  totals: { count: number; totalValue: number };
}> {
  return apiRequest(
    `/api/admin/companies/${encodeURIComponent(companyId)}/inventory/balances`,
    {
      query: params as Record<string, unknown>,
    },
  );
}

export function listAdminInventoryMovements(
  companyId: string,
  params: { limit?: number },
): Promise<{ movements: AdminInventoryMovement[] }> {
  return apiRequest(
    `/api/admin/companies/${encodeURIComponent(companyId)}/inventory/movements`,
    {
      query: params as Record<string, unknown>,
    },
  );
}